import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Row } from 'antd';
import {
  FormInputItem,
  FormSelectInput,
} from '../../../../../components/common/FormItem/FormItems';

type Props = {};

const Specific_gds_information = (props: Props) => {
  return (
    <Form.List name='client_gds_sign' initialValue={[{}]}>
      {(fields, { add, remove }) => {
        const last_filed = fields[fields.length - 1]?.name;

        return (
          <>
            {fields.map(({ key, name }) => {
              return (
                <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }}>
                  <FormSelectInput
                    label='GDS'
                    name={[name, 'gds_name']}
                    size={8}
                    placeholder='Select GDS'
                    data={[
                      { name: 'Sabre', value: 'Sabre' },
                      { name: 'Amadeus', value: 'Amadeus' },
                      { name: 'Galileo', value: 'Galileo' },
                    ]}
                  />
                  <FormInputItem
                    name={[name, 'gds_epr']}
                    size={7}
                    placeholder='User Name'
                    label='User Name'
                  />
                  <FormInputItem
                    name={[name, 'gds_creation_sign']}
                    size={7}
                    placeholder='Creation Sign'
                    label='Creation Sign'
                  />
                  <Flex gap={5} style={{ marginTop: 30 }}>
                    {last_filed === name ? (
                      <Button icon={<PlusOutlined />} onClick={() => add()} />
                    ) : null}

                    {name ? (
                      <Button danger icon={<MinusOutlined />} onClick={() => remove(name)} />
                    ) : null}
                  </Flex>
                </Row>
              );
            })}
          </>
        );
      }}
    </Form.List>
  );
};

export default Specific_gds_information;
